// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Riiq","tab":"ProcedureTabs_tab__2NRgd"};